import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute } from '@angular/router';

import { PurchaseOrderService } from '../../services/purchase-order.service';
import { PrCmpa, ProductCmpaService } from '../../services/product-cmpa.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { UnitService } from '../../services/unit.service';

import { Observable } from 'rxjs/Observable';
import { Utils } from '../../util';
import { Subscription } from 'rxjs';
import { SelectOption } from '../../globals';
import { CustomerBillData } from '../../services/customer-bill.service';

@Component({
  selector: 'app-update-purchase-order',
  templateUrl: './update-purchase-order.component.html',
  styleUrls: ['./update-purchase-order.component.css']
})
export class UpdatePurchaseOrderComponent implements OnInit, OnDestroy {

  onEdit: number = -1;

  prCmpaError: boolean = false;
  productionOrderError: boolean = false;

  supplier: any = {
    id: '',
    name: '',
    email: '',
    fiscalId: '',
    fiscalName: ''
  };

  subTotal: number = 0;
  ivaTotal: number = 0;
  total: number = 0;

  units = {};

  modalActionsPrForOrder = new EventEmitter<string|MaterializeAction>();
  modalParamsPrForOrder = [{dismissible: true}];
  
  purchaseOrderForm: FormGroup;
  prForOrderForm: FormGroup;
  currencySelect: SelectOption[] = [];

  purchaseOrder: any = {};

  sid: string;
  prForOrders = [];

  prCmpas = {};

  prCmpasInit: any;

  pickadateParams = Utils.pickadateParams();

  purchaseOrderSub: Subscription;
  productionOrderSub: Subscription;
  unitsSub: Subscription;
  prCmpasSub: Subscription;
  prCmpaSub: Subscription;

  cancelUrl: string = '/purchase_order';
  constructor(
    private purchaseOrderService: PurchaseOrderService,
    private prCmpaService: ProductCmpaService,
    private supplierService: CustomerSupplierService,
    private unitService: UnitService,
    private productionOrderService: ProductionOrderService,
    private billData: CustomerBillData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');

    if(localStorage.returnToDisplay){
      //console.log(localStorage.returnToDisplay);
      this.cancelUrl = `/vw_purchase_order/${this.sid}/fromOrder`;
      //console.log(this.cancelUrl)
      delete localStorage.returnToDisplay;
    }

     this.unitsSub = this.unitService.getUnits().subscribe(units => {
      units.map(unit => {
        this.units[unit.id] = unit.symbol;
        this.units[`Name of: ${unit.id}`] = unit.name;
      })
    })
    
  }

  ngOnInit() {
    this.createForm();
    this.createFormPrForOrder();
    this.purchaseOrderSub = this.purchaseOrderService.getPurchaseOrder(this.sid).subscribe(([purchaseOrder]) => {
      this.purchaseOrder = purchaseOrder;
      
      this.supplier.id = purchaseOrder.supplierObj.id;
      this.supplier.name = purchaseOrder.supplierObj.name;
      this.supplier.email = purchaseOrder.supplierObj.email;
      this.supplier.fiscalName = purchaseOrder.fiscalDataObj.businessName;
      
      this.purchaseOrderForm.get('date').patchValue(purchaseOrder.date);
      this.purchaseOrderForm.get('folio').patchValue(purchaseOrder.folio);
      this.purchaseOrderForm.get('notes').patchValue(purchaseOrder.notes);
      this.purchaseOrderForm.get('currency').patchValue(purchaseOrder.currency || 'key0');
      
      this.prForOrders = purchaseOrder.prForOrders;
      this.displayTotals();
    })
    
    this.productionOrders = {};
    this.productionOrderSub = this.productionOrderService.getProductionOrders({lessStatus: 'key98'}).subscribe(productionOrders => {
      this.rowsRead[0] = productionOrders.map(({id$, ...productionOrder}) => {
        return this.productionOrders[id$] = {id: id$, ...productionOrder}; 
      });
    });
    this.prCmpasSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
      prCmpas.map(prCmpa => {
        prCmpa.prices = prCmpa.prices.filter(price => price.supplierId.id == this.supplier.id)
      });
      
      const data = prCmpas.reduce((acc, cur) => {
        let characs = cur.characs.reduce((acc2, cur2, index) => `${acc2}${index ? ', ' : ''}${cur2.name.charAt(0)} ${cur2.value}${this.units[cur2.unitId.id] ? ` ${this.units[cur2.unitId.id]}` : ''}`, '');
        acc[`${cur.name}${ characs ? ` - ${characs}` : ''}`] = null;
        this.prCmpas[`${cur.name}${ characs ? ` - ${characs}` : ''}`] = cur.id;
        this.prCmpas[`Unit of: ${cur.name}${ characs ? ` - ${characs}` : ''}`] = cur.unitRef ? this.units[`Name of: ${cur.unitRef.id}`] : '';
        return acc;
      }, {});
      this.prCmpasInit = {
        'data': data
      }
    });
  }
  ngOnDestroy() {
    this.purchaseOrderSub.unsubscribe();
    this.productionOrderSub.unsubscribe();
    this.unitsSub.unsubscribe();
    this.prCmpasSub.unsubscribe();
  }

  createForm() {
    this.currencySelect = this.billData.allSelects.currency;
    this.purchaseOrderForm = this.fb.group({
      folio: ['', Validators.required],
      deliveryRequiredDate: '',
      notes: '',
      date: ['', Validators.required],
      currency: ['', Validators.required],
      change: [1, Validators.required],
    });
  }
  createFormPrForOrder() {
    this.prForOrderForm = this.fb.group({
      code: ['', Validators.required],
      name: ['', Validators.required],
      customName: ['', Validators.required],
      quantity: ['', Validators.required],
      unitName: '',
      pricePerUnit: ['', Validators.required],
      usesIva: [''],
      amountIva: [''],
      notes: '',
    });
  }

  onChangeCurrency(){
    if(this.purchaseOrderForm.get('currency').value == 'key0') this.purchaseOrderForm.get('change').patchValue(1);
    else this.prForOrders.map(pr => pr.usesIva = false);
  }

  addPrForOrder({ value, valid }: { value: any, valid: boolean }) {
    if(this.prCmpas[value.name] == undefined){
      this.prCmpaError = true;
      this.prForOrderForm.get('name').setValue('');
    }else{
      this.prCmpaSub = this.prCmpaService.getPrCmpa(this.prCmpas[value.name]).subscribe(([prCmpa]) => {
        this.prCmpaSub.unsubscribe();
        value.id = this.prCmpas[value.name];

        value.description = '';
        var cont = 0;
        prCmpa.characs.map(charact => {
          cont++;
          if(cont != 1){
            value.description += ', ';
          }
          value.description += charact.name + ': ' + charact.value + this.units[charact.unitId.id];
        })

        value.amount = value.pricePerUnit * value.quantity;
        if(value.amountIva == undefined){
          value.amountIva = 0;
        }
        this.prForOrders.push(value);
        this.displayTotals();
      });
      this.closeModalPrForOrder();
    }
    
  }
  editPrForOrder({ value, valid }: { value: any, valid: boolean },index: number){
      if(this.prCmpas[value.name]){
        this.prForOrders[index].id = this.prCmpas[value.name]
      }else{
        this.prCmpaError = true;
        return;
      }
      if(value.amountIva == undefined || value.amountIva < 0){
        value.amountIva = 0;
      }

      this.prForOrders[index].name = value.name;
      this.prForOrders[index].code = value.code;
      this.prForOrders[index].customName = value.customName;
      this.prForOrders[index].quantity = value.quantity;
      this.prForOrders[index].pricePerUnit = value.pricePerUnit;
      this.prForOrders[index].usesIva = value.usesIva;
      this.prForOrders[index].amountIva = value.amountIva;
      this.prForOrders[index].amount = value.pricePerUnit * value.quantity;
      this.prForOrders[index].notes = value.notes || '';

      this.closeModalPrForOrder();
      this.displayTotals();
  }
  deletePrForOrder(index) {
    this.prForOrders.splice(index,1);
    this.displayTotals();
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    if(!this.prForOrders.length) return toast('No hay productos.', 3000);
    if(!this.prForOrders.reduce((acc, cur) => acc && cur.amount, true)) return toast('Falta asignar precios a productos.', 3000);
    
    value.prForOrders = this.prForOrders.map((pr, prIndex) => !pr.uniqueId ? ({ uniqueId: `${Utils.String.fillLeft(`${prIndex}`, '0', 3)}${Utils.randomString(3)}`, ...pr }) : pr);
    value.subTotal = this.subTotal;
    value.ivaTotal = this.ivaTotal;
    value.total = this.total;
    this.purchaseOrderService.updatePurchaseOrder(this.sid,value);
    this.purchaseOrderService.router.navigate([`/vw_purchase_order/${this.sid}/fromEdit`]);
  }

  openModalPrForOrder(index: number) {
    this.onEdit = index;
    this.prForOrderForm.reset();
    this.prCmpaError = false;
    if(index == -1){
      this.prForOrderForm.get('usesIva').patchValue(false);
    }else{
      this.prForOrderForm.get('code').setValue(this.prForOrders[index].code);
      this.prForOrderForm.get('name').setValue(this.prForOrders[index].name);
      this.prForOrderForm.get('customName').setValue(this.prForOrders[index].customName);
      this.prForOrderForm.get('quantity').setValue(this.prForOrders[index].quantity);
      this.prForOrderForm.get('pricePerUnit').setValue(this.prForOrders[index].pricePerUnit);
      this.prForOrderForm.get('usesIva').setValue(this.prForOrders[index].usesIva);
      this.prForOrderForm.get('amountIva').patchValue(this.prForOrders[index].amountIva);
      this.prForOrderForm.get('notes').patchValue(this.prForOrders[index].notes);
    }
    this.modalActionsPrForOrder.emit({ action: 'modal', params: ['open'] });
  }
  closeModalPrForOrder() {
    this.modalActionsPrForOrder.emit({ action: 'modal', params: ['close'] });
  }

  displayTotals(){
    var subTotal = 0;
    var ivaTotal = 0;
    this.prForOrders.map(item => {
      subTotal += item.amount;
      if(item.usesIva){
        ivaTotal += (item.amount * (item.amountIva / 100));
      }
    });
    var total = subTotal + ivaTotal;
    
    this.subTotal = +subTotal.toFixed(2);
    this.ivaTotal = +ivaTotal.toFixed(2);
    this.total = +total.toFixed(2);

  }

  suggestData(){
    const productName = this.prForOrderForm.get('name').value;
    let prCmpaId = this.prCmpas[productName];
    if(!prCmpaId) return toast('Escriba un producto válido.', 3000);
    this.prForOrderForm.get('customName').patchValue(productName);
    
    let prCmpaSub= this.prCmpaService.getPrCmpa(prCmpaId).subscribe(([prCmpa]) => {
      prCmpaSub.unsubscribe();
      let prices = prCmpa.prices.sort(({currency='key0'}) => currency == this.purchaseOrderForm.get('currency').value ? -1 : 1).sort(({supplierId}) => supplierId.id == this.supplier.id ? -1 : 1);
      let [{price=0, usesIva=false, amountIva=0}={}] = (prices.length ? prices : prCmpa.prices).sort(({price: p1}, {price: p2}) => p2 - p1);
      this.prForOrderForm.get('code').setValue(prCmpa.code);
      this.prForOrderForm.get('pricePerUnit').setValue(price);
      this.prForOrderForm.get('usesIva').setValue(usesIva);
      this.prForOrderForm.get('amountIva').patchValue(amountIva);
      //console.log(this.prCmpas);
      //console.log(`Unit of: ${productName}`,this.prCmpas[`Unit of: ${productName}`]);
      this.prForOrderForm.get('unitName').patchValue(this.prCmpas[`Unit of: ${productName}`] || '');
    });
  }



  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  //ProductionOrder
  productionOrders: any = {};
  currentPrIndex: number = -1;

  currentReadIndex: number;
  rowsRead = [[]];
  columnsRead = [
    [
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' }
    ]
  ]

  openModalRead(index: number, prIndex: number) {
    this.currentReadIndex = index;
    this.currentPrIndex = prIndex;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row: odp}): any{
    this.prForOrders[this.currentPrIndex].odpId = odp.id;
    this.prForOrders[this.currentPrIndex].odpName = odp.name;
    this.prForOrders[this.currentPrIndex].customerName = odp.customer && odp.customer.name || '';
    this.closeModalRead();
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
